import { selectLastConsultation, selectConsultationPatient } from '@app/store/consultation/consultation.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { smartRecoFeatureKey } from '../smart-reco-feature-key';
import { SmartRecoState } from '../smart-reco.state';

const selectState = createFeatureSelector<SmartRecoState>(smartRecoFeatureKey);
/**
 * Select forms values
 */
export const selectPathologies = createSelector(selectState, (state) => state.pathologies);

/**
 * Select patient Ideal Body Weight
 */
export const selectPatientIbw = createSelector(selectConsultationPatient, selectLastConsultation, (patient, lastConsultation) => {
  return patient?.pet?.idealBodyWeight || lastConsultation?.visit?.weight;
});
